import { render, staticRenderFns } from "./SwapSessionTab.vue?vue&type=template&id=36bdbd53&scoped=true&lang=pug"
import script from "./SwapSessionTab.vue?vue&type=script&lang=js"
export * from "./SwapSessionTab.vue?vue&type=script&lang=js"
import style0 from "./SwapSessionTab.vue?vue&type=style&index=0&id=36bdbd53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bdbd53",
  null
  
)

export default component.exports